import React from 'react';

import Img from 'retired/Img';
import Box from 'retired/Box';
import puzzlePiece from 'assets/puzzle-piece.avif';

import { AddAffiliationButton } from './AddAffiliationButton';

const AddAffiliationsBanner = (): JSX.Element => (
  <Box
    style={{
      marginTop: 30,
    }}
  >
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
      }}
    >
      <div
        style={{
          position: 'relative',
          top: -25,
          alignSelf: 'top',
        }}
      >
        <Img
          src={puzzlePiece}
          alt="Volunteer Affiliation"
          style={{
            width: 140,
          }}
        />
      </div>
      <div
        style={{
          flex: 1,
        }}
      >
        <h3>Add Employee Affiliations to Nonprofits</h3>
        <p>
          Add Nonprofit Affiliations on behalf of this employee. Affiliations will be visible to the
          employee on their profile where they will be able to make updates.
        </p>
      </div>
      <div>
        <AddAffiliationButton />
      </div>
    </div>
  </Box>
);
export default AddAffiliationsBanner;
